<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.5 14.5L11.45 18.5L18.5 7.5" stroke="currentColor" />
  </svg>
</template>
